/* tslint:disable */

/* eslint-disable */

/**
 * API Gateway Backstage Plugin
 * Backstage plugins api spec
 *
 * The version of the OpenAPI document: v1
 * Contact: sarkan.mo@tomtom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { RouteForward } from './RouteForward';
import { RouteForwardFromJSON, RouteForwardToJSON } from './RouteForward';

/**
 *
 * @export
 * @interface Route
 */
export interface Route {
  /**
   * The name of the route.
   * @type {string}
   * @memberof Route
   */
  name?: string;
  /**
   * A list of matchers for the route.
   * @type {Array<string>}
   * @memberof Route
   */
  matchers?: Array<string>;
  /**
   * A list of policies to apply to the route. contains name of policy and a string which is a yaml object.
   * @type {{ [key: string]: string; }}
   * @memberof Route
   */
  policies?: { [key: string]: string };
  /**
   *
   * @type {RouteForward}
   * @memberof Route
   */
  forward?: RouteForward;
}

/**
 * Check if a given object implements the Route interface.
 */
// @ts-ignore
export function instanceOfRoute(value: object): value is Route {
  return true;
}

export function RouteFromJSON(json: any): Route {
  return RouteFromJSONTyped(json, false);
}

export function RouteFromJSONTyped(
  json: any,
  // @ts-ignore
  ignoreDiscriminator: boolean,
): Route {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
    matchers: json['matchers'] == null ? undefined : json['matchers'],
    policies: json['policies'] == null ? undefined : json['policies'],
    forward:
      json['forward'] == null
        ? undefined
        : RouteForwardFromJSON(json['forward']),
  };
}

export function RouteToJSON(json: any): Route {
  return RouteToJSONTyped(json, false);
}

export function RouteToJSONTyped(
  value?: Route | null,
  // @ts-ignore
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
    matchers: value['matchers'],
    policies: value['policies'],
    forward: RouteForwardToJSON(value['forward']),
  };
}
